import React from "react";
import { Input, Space, Button } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";

const handleReset = (clearFilters, confirm, setSearchText) => {
  clearFilters();
  confirm();
  setSearchText("");
};

const handleSearch = (
  selectedKeys,
  confirm,
  dataIndex,
  setSearchText,
  setSearchedColumn,
) => {
  confirm();
  setSearchText(selectedKeys[0]);
  setSearchedColumn(dataIndex);
};

export const getColumnSearchProps = (options) => {
  const {
    searchInput,
    searchText,
    searchedColumn,
    setSearchText,
    setSearchedColumn,
  } = options;

  return (dataIndex, type) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(
              selectedKeys,
              confirm,
              dataIndex,
              setSearchText,
              setSearchedColumn,
            )
          }
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(
                selectedKeys,
                confirm,
                dataIndex,
                setSearchText,
                setSearchedColumn,
              )
            }
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() =>
              clearFilters && handleReset(clearFilters, confirm, setSearchText)
            }
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) => {
      // to remove undefined and null values from record index array
      const Filteredarray = [record[dataIndex]].filter((a) => a);
      // to remove undefined and null values from record array
      const FalseDataFilteredarray = [record[dataIndex]].filter((a) => a === a);

      if (value === "Not Available") {
        return record[dataIndex]
          ? record[dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          : "Not Available";
      }
      if (value === "false") {
        return FalseDataFilteredarray
          ? FalseDataFilteredarray.toString()
              .toLowerCase()
              .includes(value.toString().toLowerCase())
          : "false";
      }
      return Filteredarray.toString()
        .toLowerCase()
        .includes(value.toLowerCase());
    },
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex && text ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
};

export const tableStringSorter = (key) => {
  return (value1, value2) => {
    const stringValue1 = value1[key] ? value1[key] : "a";
    const stringValue2 = value2[key] ? value2[key] : "a";
    return stringValue1.localeCompare(stringValue2);
  };
};

export const tableNumericSorter = (key, defaultValue = 999999) => {
  return (value1, value2) => {
    const numericValue1 = !Number.isNaN(value1[key])
      ? Number(value1[key])
      : defaultValue;
    const numericValue2 = !Number.isNaN(value2[key])
      ? Number(value2[key])
      : defaultValue;
    return numericValue1 - numericValue2;
  };
};

export default {
  getColumnSearchProps,
  tableStringSorter,
};
